/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TDesktopGetNotificationsRequest,
  TDesktopGetNotificationsModel,
  IMappers,
  TDesktopGetNotificationsResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetNotificationsDesktopResponse } from '../../../entities/get_for_desktop/GetNotificationsDesktopResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createDesktopGetNotificationsModel(
  parameters: TDesktopGetNotificationsRequest,
): TDesktopGetNotificationsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'notification-center',
    pathApi: '/v1/desktop/get-notifications/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IDesktopGetNotificationsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TDesktopGetNotificationsRequest;
}

export async function fetchDesktopGetNotifications<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IDesktopGetNotificationsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TDesktopGetNotificationsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createDesktopGetNotificationsModel(parameters),
    config,
  )) as FetchResponse<TDesktopGetNotificationsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNotificationsDesktopResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TDesktopGetNotificationsResponse>;
}
